/** @File Helpers for making JSON REST api requests */
import * as R from 'ramda';

type JsonApiResult = {
  data?: unknown,
  error?: string
};

 /**
  * Rejects or Resolves a promise based on the fetch api response.
  * @returns Rejected promise if response is not 200
  * @returns Rejected promise if JSON response body has an `error` key
  * @returns Resolved promise containing the `data` key if present in response
  */
export async function handleResponse<T>(response: Response): Promise<T> {
  const json: (_: Response) => Promise<JsonApiResult> = R.pipe(
    R.invoker(0, 'json'),
    R.otherwise(err => ({error: err}))
  );
  switch (response.status) {
    case 200: {
      const responseBody = await json(response);
      return responseBody.error
        ? Promise.reject(new Error(responseBody.error as string))
        : Promise.resolve(responseBody.data as T);
    }

    default:
      return json(response).then(json => {
        throw new Error(
          R.has('error', json)
            ? R.prop('error', json) as string
            : `HttpStatusCode ${response.status}`
        );
      });
  }
}
